import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import useBreakpoints from './breakpoint.mixin';


export default /*#__PURE__*/_defineComponent({
  __name: 'Breakpoints',
  props: {
    sizes: null
  },
  setup(__props: any) {

const props = __props as { sizes: string[] }


const breakpointIsActive = useBreakpoints();

const visible = computed<boolean>(() => {
    return props.sizes.some(size => breakpointIsActive.value[size]);
});

return { __sfc: true,props, breakpointIsActive, visible }
}

})